import { render, staticRenderFns } from "./reportDetail.vue?vue&type=template&id=32db70e4&scoped=true"
import script from "./reportDetail.vue?vue&type=script&lang=ts"
export * from "./reportDetail.vue?vue&type=script&lang=ts"
import style0 from "./reportDetail.vue?vue&type=style&index=0&id=32db70e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32db70e4",
  null
  
)

export default component.exports